<template>
    <v-stepper :value="activeStepper" vertical>
        <div class="text-xs-center">
            <img src="/src/assets/images/icons/heart-red.svg" />
            <h1 class="stepper-title title-content --no-border mb-0 mt-2" style="font-size: 21px; color: #1d1d1d">
                {{
                    changeSurveyText
                        ? $t('UPDATE_YOUR_DATA')
                        : $t('THANK_YOU_FOR_REGISTRATION', { name: user.firstName })
                }}
            </h1>
            <p class="mb-5" style="font-size: 16px; font-weight: 400; color:  #1d1d1d">
                {{ $t('ANSWER_BELOW_QUESTIONS') }}
            </p>
        </div>
        <section class="stepper-section">
            <language-selection />
        </section>
        <section class="stepper-section">
            <v-stepper-step step="1" :complete="activeStepper > 1">
                <img src="/src/assets/images/icons/ok-gray.svg" />
                {{ $t('WHERE_DID_YOU_GET_BRASTER_FROM') }}
            </v-stepper-step>
            <v-stepper-content step="1">
                <survey-step1-q1 />
            </v-stepper-content>
        </section>
        <section class="stepper-section">
            <v-stepper-step step="2" :complete="activeStepper > 2">
                <img src="/src/assets/images/icons/ok-gray.svg" />
                {{ $t('PERSONAL_DATA') }}
            </v-stepper-step>
            <v-stepper-content step="2">
                <survey-step5-q1 v-if="survey.section5.active_section === 1" />
                <survey-step5-q2 v-if="survey.section5.active_section === 2" />
                <survey-ireland-agreement v-if="survey.section5.active_section === 3" />
            </v-stepper-content>
        </section>
        <section class="stepper-section">
            <v-stepper-step step="3" :complete="activeStepper > 3">
                <img src="/src/assets/images/icons/ok-gray.svg" />
                {{ $t('CAN_I_USE_BRASTER') }}
            </v-stepper-step>
            <v-stepper-content step="3">
                <survey-step2-q1 v-if="survey.section2.active_section === 1" />
                <survey-step2-q2 v-if="survey.section2.active_section === 2" />
                <survey-step2-q3 v-if="survey.section2.active_section === 3" />
                <survey-step2-q4 v-if="survey.section2.active_section === 4" />
            </v-stepper-content>
            <survey-disallowed-by-pregnant @close="closeModal" v-if="survey.section2.disallow_by_pregnant" />
            <survey-disallowed-by-breast-cancer @close="closeModal" v-if="survey.section2.disallow_by_breast_cancer" />
            <survey-disallowed-by-breast-surgery
                @close="closeModal"
                v-if="survey.section2.disallow_by_breast_surgery"
            />
            <survey-disallowed-by-breast-enlargament
                @close="closeModal"
                v-if="survey.section2.disallow_by_breast_enlargement"
            />
        </section>
        <section class="stepper-section">
            <v-stepper-step step="4" :complete="activeStepper > 4">
                <img src="/src/assets/images/icons/ok-gray.svg" />
                {{ $t('RISK_FACTORS') }}
            </v-stepper-step>
            <v-stepper-content step="4">
                <survey-step3-q1 v-if="survey.section3.active_section === 1" />
                <survey-step3-q2 v-if="survey.section3.active_section === 2" />
                <survey-step3-q2-observe v-if="survey.section3.active_section === 3" />
                <survey-step3-q3 v-if="survey.section3.active_section === 4" />
                <survey-step3-q4 v-if="survey.section3.active_section === 5" />
                <survey-step3-q5 v-if="survey.section3.active_section === 6" />
                <survey-step3-q5-after v-if="survey.section3.active_section === 7" />
                <survey-step3-q6 v-if="survey.section3.active_section === 8" />
                <survey-step3-q7 v-if="survey.section3.active_section === 9" />
                <survey-step3-q8 v-if="survey.section3.active_section === 10" />
            </v-stepper-content>
        </section>
        <section class="stepper-section">
            <v-stepper-step step="5" :complete="activeStepper > 5">
                <img src="/src/assets/images/icons/ok-gray.svg" />
                {{ $t('MEDICAL_DATA') }}
            </v-stepper-step>
            <v-stepper-content step="5">
                <survey-step4-q1 v-if="survey.section4.active_section === 1" />
                <survey-step4-q2 v-if="survey.section4.active_section === 2" />
                <survey-step4-q3 v-if="survey.section4.active_section === 3" />
                <survey-step4-q4 v-if="survey.section4.active_section === 4" />
                <survey-step3-q9 v-if="survey.section4.active_section === 5" />
            </v-stepper-content>
        </section>
        <section class="stepper-section">
            <div class="stepper-completed" v-if="survey.stepperComplete">
                <img src="/src/assets/images/icons/ico-ok-green.png" />
                <h3 v-if="!changeSurveyText">{{ $t('THANK_YOU') }}</h3>
                <p>{{ $t(changeSurveyText ? 'THANK_YOU_FOR_UPDATE' : 'YOU_CAN_START_BRASTER') }}</p>
                <button @click="finishSurvey" class="w160 app-btn app-btn-primary">
                    {{ $t('CLOSE_WINDOW') }}
                </button>
            </div>
        </section>
    </v-stepper>
</template>

<script>
import languageSelection from './language-selection.vue';
import surveyStep1Q1 from './survey-step1-q1.vue';
import surveyStep2Q1 from './survey-step2-q1.vue';
import surveyStep2Q2 from './survey-step2-q2.vue';
import surveyStep2Q3 from './survey-step2-q3.vue';
import surveyStep2Q4 from './survey-step2-q4.vue';
import surveyStep3Q1 from './survey-step3-q1.vue';
import surveyStep3Q2 from './survey-step3-q2.vue';
import surveyStep3Q2Observe from './survey-step3-q2-observe.vue';
import surveyStep3Q3 from './survey-step3-q3.vue';
import surveyStep3Q4 from './survey-step3-q4.vue';
import surveyStep3Q5 from './survey-step3-q5.vue';
import surveyStep3Q5After from './survey-step3-q5-after.vue';
import surveyStep3Q6 from './survey-step3-q6.vue';
import surveyStep3Q7 from './survey-step3-q7.vue';
import surveyStep3Q8 from './survey-step3-q8.vue';
import surveyStep3Q9 from './survey-step3-q9.vue';
import surveyStep4Q1 from './survey-step4-q1.vue';
import surveyStep4Q2 from './survey-step4-q2.vue';
import surveyStep4Q3 from './survey-step4-q3.vue';
import surveyStep4Q4 from './survey-step4-q4.vue';
import surveyStep5Q1 from './survey-step5-q1.vue';
import surveyStep5Q2 from './survey-step5-q2.vue';
import surveyDisallowedByPregnant from './survey-disallowed-by-pregnant.vue';
import surveyDisallowedByBreastCancer from './survey-disallowed-by-breast-cancer.vue';
import surveyDisallowedByBreastSurgery from './survey-disallowed-by-breast-surgery.vue';
import surveyDisallowedByBreastEnlargament from './survey-disallowed-by-breast-enlargament.vue';
import surveyIrelandAgreement from './survey-ireland-agreement.vue';
import { eventBus } from './../../../main';
import { mapActions, mapState } from 'vuex';
import { mapMedicalData, mapUserSurveyData } from '../../../main';

export default {
    computed: {
        ...mapState(['user']),
        activeStepper() {
            return this.$store.getters.survey.activeStepper;
        },
        survey() {
            return this.$store.getters.survey;
        },
        changeSurveyText() {
            return this.user.patient.ehrId != null;
        },
    },
    components: {
        surveyStep1Q1,
        surveyStep2Q1,
        surveyStep2Q2,
        surveyStep2Q3,
        surveyStep2Q4,
        surveyStep3Q1,
        surveyStep3Q2,
        surveyStep3Q2Observe,
        surveyStep3Q3,
        surveyStep3Q4,
        surveyStep3Q5,
        surveyStep3Q5After,
        surveyStep3Q6,
        surveyStep3Q7,
        surveyStep3Q8,
        surveyStep3Q9,
        surveyStep4Q1,
        surveyStep4Q2,
        surveyStep4Q3,
        surveyStep4Q4,
        surveyStep5Q1,
        surveyStep5Q2,
        surveyDisallowedByPregnant,
        surveyDisallowedByBreastCancer,
        surveyDisallowedByBreastSurgery,
        surveyDisallowedByBreastEnlargament,
        surveyIrelandAgreement,
        languageSelection,
    },
    watch: {
        survey: {
            handler: 'scrollInSurvey',
            deep: true,
        },
    },
    methods: {
        ...mapActions(['updateUserSurvey']),
        finishSurvey() {
            mapMedicalData();
            const updateComposition = this.$http.post('/openehr/api/composition/', this.$store.state.medicalData);
            const updateUserSurvey = this.updateUserSurvey({
                ...this.user.patient.survey,
                ...mapUserSurveyData(),
                completionStage: 'MEDICAL_DATA_SET',
            });
            Promise.all([updateComposition, updateUserSurvey]).then(this.closeModal);
        },
        closeModal() {
            this.$emit('close');
            this.$scrollTo('#app', 500, { offset: -30 });
            eventBus.$emit('reloadMyAccount');
        },
        scrollInSurvey() {
            let position;
            switch (this.activeStepper) {
                case 1:
                    position = 500;
                    break;
                case 2:
                    position = 691;
                    break;
                case 3:
                    position = 791;
                    break;
                case 4:
                    position = 891;
                    break;
                case 5:
                    position = 991;
                    break;
                case 6:
                    position = 1091;
                    break;
            }
            this.$scrollTo('#app', 1000, { offset: position });
        },
    },
};
</script>

<style lang="scss">
@media (max-width: 500px) {
    .modal {
        padding: 0 5px;
    }

    .modal-content {
        padding: 8px;
        margin-top: 30px;
    }

    .surveyModal {
        .modal-content {
            padding: 30px 0;
        }
    }

    .el-col-xs-12 {
        width: 100%;
    }

    .stepper__wrapper {
        height: 100% !important;
    }
}
</style>



// WEBPACK FOOTER //
// survey.vue?e41f8f18